import {
  Halal,
  Kosher,
  GlutenFree,
  Vegan,
  Vegetarian,
  DairyFree,
  ContainsNuts,
  NutFree,
  Spicy,
  Reusable,
  Recycleable,
  IndPackage,
  Exclusive,
  BoxedMeal,
} from "assets/img";

import { toTitleCase } from "./string";

const getBadgeIcon = (badge) => {
  switch (getParentTag(toTitleCase(badge))) {
    case "Halal":
      return Halal;
    case "Kosher":
      return Kosher;
    case "Gluten Free":
      return GlutenFree;
    case "Vegetarian":
      return Vegetarian;
    case "Vegan":
      return Vegan;
    case "Dairy Free":
      return DairyFree;
    case "Spicy":
      return Spicy;
    case "Nut Free":
      return NutFree;
    case "Contains Nuts":
      return ContainsNuts;
    case "Reusable":
      return Reusable;
    case "Recycleable":
      return Recycleable;
    case "IndPackage":
      return IndPackage;
    case "Exclusive":
      return Exclusive;
    case "Boxed Meal":
      return BoxedMeal;

    default:
      return null;
  }
};

const getParentTag = (badge) => {
  switch (badge) {
    case "Gluten Free":
    case "Gluten Free Friendly":
    case "Gluten Free Kitchen":
      return "Gluten Free";

    case "Vegan":
    case "Vegan Friendly":
    case "100% Vegan":
    case "100% Plant Based":
    case "Plant Based":
      return "Vegan";

    case "Vegetarian":
    case "Vegetarian Friendly":
    case "Vegan":
    case "Vegan Friendly":
    case "100% Vegan":
    case "100% Plant Based":
    case "Plant Based":
      return "Vegetarian";

    case "hungerhub exclusive menu":
    case "hungerhub exclusive catering":
    case "Exclusive":
      return "Exclusive";

    case "Halal":
      return "Halal";

    case "Nut free":
    case "Peanut free kitchen":
    case "Nut free kitchen":
    case "nut free friendly":
      return "Nut Free";

    case "Eco-friendly Packaging":
    case "Biodegradable Packaging":
    case "Sustainable Packaging":
    case "Reusable Containers":
      return "Recycleable";

    case "Reusable Packaging":
      return "Reusable";

    case "Boxed Meal":
      return "Boxed Meal";

    case "Individually Packaged":
      return "IndPackage";

    default:
      return badge;
  }
};

const menuItemBadge = (badge) => {
  switch (
    typeof badge === "string"
      ? badge.replace(/\s+/g, "")
      : badge?.name?.replace(/\s+/g, "")
  ) {
    case "HALAL":
      return Halal;
    case "KOSHER":
      return Kosher;
    case "GLUTENFREE":
      return GlutenFree;
    case "VEGETARIAN":
      return Vegetarian;
    case "VEGAN":
      return Vegan;
    case "DAIRYFREE":
      return DairyFree;
    case "EXCLUSIVE":
      return Exclusive;
    case "SPICY":
      return Spicy;
    case "NUTFREE":
      return NutFree;
    case "CONTAINSNUTS":
      return ContainsNuts;
    case "REUSABLEPACKAGING":
      return Reusable;
    default:
      return Halal;
  }
};

const cardBrandIcons = {
  amex: "https://img.icons8.com/color/48/amex.png",
  discover: "https://img.icons8.com/color/48/discover.png",
  diners: "https://img.icons8.com/color/48/diners-club.png",
  jcb: "https://img.icons8.com/color/48/jcb.png",
  union_pay: "https://img.icons8.com/color/48/unionpay.png",
  interac: "https://img.icons8.com/color/48/interac.png",
  default: "https://img.icons8.com/color/48/bank-card-back-side.png",
};

export default {
  getBadgeIcon,
  menuItemBadge,
  cardBrandIcons,
};
